<template>
  <b-row>
    <b-col>
      <b-row id="excmcase_search">
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label for="excmcase_search_id" class="form-control-label">{{ $t('views.excmcase.list.searchParams.id') }}:</label>
            <input type="text" id="excmcase_search_id" class="form-control" v-model.lazy="searchParams.caseNumber" v-debounce="delay" :placeholder="$t('views.excmcase.list.searchParams.idPlaceholder')">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label for="excmcase_search_subtitle" class="form-control-label">{{ $t('views.excmcase.list.searchParams.description') }}:</label>
            <input type="text" id="excmcase_search_subtitle" class="form-control" v-model.lazy="searchParams.description" v-debounce="delay" :placeholder="$t('views.excmcase.list.searchParams.descriptionPlaceholder')">
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label for="excmcase_search_lastTask" class="form-control-label">
              {{ $t('views.excmcase.show.currentTask') }}:
            </label>
            <multi-select :placeholder="$t('views.excmcase.show.currentTask')" @select="onSelectCurrentTaskType" :options="taskTypeOptionsList" :selected-options="currentTaskType"></multi-select>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.excmcase.list.searchParams.keyTask') }}:
            </label>
            <multi-select :placeholder="$t('views.excmcase.list.searchParams.keyTask')" @select="onSelectKeyTaskType" :options="keyTaskTypeOptionsList" :selected-options="keyTaskType"></multi-select>
          </div>
        </b-col>
      </b-row>
      <!--  OWNER-->
      <b-row>
        <b-col lg="3">
          <b-form-group>
            <label>{{ $t('views.excmcase.form.ownerUserData') }}</label>
            <base-select-input
              v-model="searchParams.ownerUserData"
              :search-callback="ownerUserDataSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </b-form-group>
        </b-col>
        <!--    CONTRACTOR-->
        <b-col lg="3">
          <b-form-group>
            <label>{{ $t('views.excmcase.form.contractorUserData') }}</label>
            <base-select-input
              v-model="searchParams.contractorUserData"
              :search-callback="contractorSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </b-form-group>
        </b-col>
        <!--    PARNTER-->
        <b-col lg="3">
          <b-form-group>
            <label>{{ $t('views.excmcase.form.partnerUserData') }}</label>
            <base-select-input
              v-model="searchParams.partnerUserData"
              :search-callback="partnerSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </b-form-group>
        </b-col>
        <b-col cols="1">
          <div class="form-group mt-3">
            <label class="form-control-label">{{ $t('views.excmnote.list.filters.state') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="searchParams.state"
                :options="radioOptionsState"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="1">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmcase.list.searchParams.disableRolesFiltering') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="searchParams.disableRolesFiltering"
                :options="radioOptionsDisableRolesFiltering"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="1">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmtask.list.deadlineExceeded') }}:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="searchParams.caseFilterByProgress"
                :options="radioOptionsDisableRolesFiltering"
                buttons
                button-variant="outline-primary"
                name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="false">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmcase.list.searchParams.highPriority') }}:</label>
            <b-form-group>
              <b-form-radio-group
                      v-model="searchParams.highPriority"
                      :options="radioOptions"
                      buttons
                      button-variant="outline-primary"
                      name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
            <!--                        <b-form-checkbox v-model="searchParams.highPriority" name="check-button" switch size="lg"></b-form-checkbox>-->
          </div>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label for="serviceman_filter">{{ $t('routes.ServicemenShow') }}</label>
            <model-select
              :placeholder="$t('routes.ServicemenShow')"
              id="serviceman_filter"
              v-model="searchParams['lastTask.lastPoolTask.operationTransferUserData']" :options="userDataOptions"></model-select>
          </b-form-group>
        </b-col>
        <b-col v-if="false">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmcase.list.searchParams.activeOnly') }}:</label>
            <b-form-group>
              <b-form-radio-group
                      v-model="searchParams.activeOnly"
                      :options="radioOptions"
                      buttons
                      button-variant="outline-primary"
                      name="radios-btn-default"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="3">
          <div class="form-group">
            <label for="customfields_search_id" class="form-control-label">{{ $t('views.excmcase.list.searchParams.filterTaskByCustomField') }}:</label>
            <input type="text" id="customfields_search_id" class="form-control" v-model.lazy="searchParams.filterTaskByCustomField" v-debounce="delay" :placeholder="$t('views.excmcase.list.searchParams.filterTaskByCustomField')">
          </div>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label for="serviceman_filter">{{ $t('views.excmcase.list.searchParams.keyUserData') }}</label>
            <model-select
              :placeholder="$t('views.excmcase.list.searchParams.keyUserData')"
              id="serviceman_filter"
              v-model="searchParams['idKeyUserData']" :options="keyUserDataOptionsList"></model-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
        </b-col>
      </b-row>
      <b-row v-if="ableToListDevices">
        <b-col cols="12">
<!--          DEVICE-->
          <hr class="my-1">
          <h6>{{ $t('views.excmcase.show.device') }}:</h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.excmcase.list.searchParams.city') }}:
            </label>
            <input type="text" class="form-control"
                   :placeholder="$t('views.excmcase.list.searchParams.cityPlaceholder')"
                   v-model.lazy="searchParams['idDevice.city']" v-debounce="delay">
          </div>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.excmcase.list.searchParams.street') }}:
            </label>
            <input type="text" class="form-control"
                   :placeholder="$t('views.excmcase.list.searchParams.streetPlaceholder')"
                   v-model.lazy="searchParams['idDevice.street']" v-debounce="delay">
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmcase.list.searchParams.deviceType') }}:</label>
            <el-select
              class="select-default"
              v-model.lazy="searchParams['idDevice.idDeviceModel.idDeviceType']"
              v-debounce="delay"
              :placeholder="$t('views.excmcase.list.searchParams.deviceTypePlaceholder')">
              <el-option
                class="select-default"
                v-for="item in deviceTypeOptions"
                :key="item['@id']"
                :label="item.title"
                :value="item['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.excmcase.list.searchParams.device') }}:
            </label>
            <input type="text" class="form-control"
                   :placeholder="$t('views.excmcase.list.searchParams.devicePlaceholder')"
                   v-model.lazy="searchParams['idDevice.idDeviceModel.idDeviceBrand.brandTitle']"
                   v-debounce="delay">
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.excmcase.list.searchParams.serialNumber') }}:
            </label>
            <input type="text" class="form-control"
                   :placeholder="$t('views.excmcase.list.searchParams.serialNumberPlaceholder')"
                   v-model.lazy="searchParams['idDevice.serialNumber']" v-debounce="delay">
          </div>
        </b-col>
      </b-row>
      <b-row v-if="ableToListAgreements">
        <b-col cols="12">
          <hr class="my-1">
          <h6>{{ $t('views.excmagreements.show.title') }}:</h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.excmcase.list.searchParams.firm') }}:
            </label>
            <input type="text" class="form-control"
                   :placeholder="$t('views.excmcase.list.searchParams.firmPlaceholder')"
                   v-model.lazy="searchParams['agreement.company.firmname1']" v-debounce="delay">
          </div>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="form-group">
            <label class="form-control-label">
              {{ $t('views.agreements.list.agreementNumber') }}:
            </label>
            <input type="text" class="form-control"
                   :placeholder="$t('views.agreements.list.agreementNumber')"
                   v-model.lazy="searchParams['agreement.agreementNumber']" v-debounce="delay">
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce' // search params with delay when typing
import getId from '@/utils/getIdFromLink'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'

export default {
  name: 'Filtering',
  components: {
    ModelSelect,
    MultiSelect,
    BaseSelectInput
  },
  props: {
    isSalesRepresentative: {
      required: false
    },
    isWholesaler: {
      required: false
    },
    externalStatus: {
      required: false
    },
    deviceTypeOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    caseTypeOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    getPage: {
      type: Function,
      default: () => {
        console.log('function not exists')
      }
    },
    idCasesType: {
      required: false
    }
  },
  watch: {
    searchParams: {
      handler () {
        this.$emit('getPage', this.getProcessedParams())
      },
      deep: true
    },
    idCasesType (val) {
      this.fetchUserDataOptions(val)
    }
  },

  directives: {
    debounce
  },
  computed: {
    ableToListDevices () {
      return checkPermission('devices', 'EXCMDeviceList')
    },
    ableToListAgreements () {
      return checkPermission('agreements', 'EXCMAgreementList')
    },
    taskTypeOptionsList () {
      if (this.idCasesType) {
        return this.taskTypeOptions.filter(item => getId(item.idCasesType) === this.idCasesType || item.idCasesType === null)
      }
      return this.taskTypeOptions
    },
    keyTaskTypeOptionsList () {
      if (this.idCasesType) {
        let currentCaseType = this.caseTypeOptions.find(item => item.value === this.idCasesType)
        let keyTaskTypeIds = currentCaseType.keyTaskTypes
        if (!Array.isArray(keyTaskTypeIds)) {
          keyTaskTypeIds = []
        }
        return this.taskTypeOptionsList.filter(item => keyTaskTypeIds.includes(item.value.toString()))
      }
      return this.taskTypeOptionsList
    },
    keyUserDataOptionsList () {
      if (this.idCasesType) {
        let currentCaseType = this.caseTypeOptions.find(item => item.value === this.idCasesType)
        let keyUserIds = currentCaseType.keyRoles
        if (!Array.isArray(keyUserIds)) {
          keyUserIds = []
        }
        return this.userDataOptions.filter(item => keyUserIds.includes(item.idClientType.toString()))
      }
      return this.userDataOptions
    }
  },
  data () {
    return {
      delay: 500,
      currentTaskType: [],
      keyTaskType: [],
      searchParams: {
        highPriority: false,
        activeOnly: true,
        status: this.externalStatus,
        state: 1,
        disableRolesFiltering: (this.isSalesRepresentative || this.isWholesaler || getUserRoles().default_disable_roles_filtering) ? 1 : 0,
        'lastTask.lastPoolTask.operationTransferUserData': null,
        'filterTaskByCustomField': '',
        caseType: this.idCasesType,
        idKeyUserData: null,
        'lastTask.idTaskType': [],
        'idKeyTask.idTaskType': []
      },
      userDataOptions: [],
      taskTypeOptions: [],
      radioOptions: [
        {
          value: false,
          text: this.$t('buttons.no')
        },
        {
          value: true,
          text: this.$t('buttons.yes')
        }
      ],
      radioOptionsState: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      radioOptionsDisableRolesFiltering: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        }
      ]
    }
  },
  created () {
    this.fetchTaskTypeOptions()
    this.fetchUserDataOptions(this.idCasesType)
  },
  methods: {
    getProcessedParams () {
      let searchParams = JSON.parse(JSON.stringify(this.searchParams))
      searchParams.caseType = this.idCasesType
      Object.keys(searchParams).forEach(key => {
        if (typeof searchParams[key] === 'string' && key !== 'caseNumber') {
          searchParams[key] = getId(searchParams[key])
        }
      })
      return searchParams
    },
    async fetchTaskTypeOptions () {
      let params = { pagination: false, forFiltering: 1 }
      const response = await new ApiService('e_x_c_m_task_types', params).getResults()
      this.taskTypeOptions = response.items.map(type => {
        return {
          value: getId(type['@id']),
          text: type.title + (type.idCasesType ? ' (' + type.idCasesType.title + ')' : ''),
          idCasesType: type.idCasesType ? getId(type.idCasesType['@id']) : null
        }
      })
    },
    async contractorSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1, idClientType: 7 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async ownerUserDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 0, idClientType: [...this.$store.getters['configuration/customClientTypeIds'], 4, 5, 13, 14, 15, 16] }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async partnerSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1, state: 1, idClientType: this.$store.getters['configuration/clientTypesForPartnerUserData'] }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async fetchUserDataOptions (applicableForTaskTypeInsideCaseType = null) {
      let params = { pagination: false, isContractor: 0, idClientType: [...this.$store.getters['configuration/customClientTypeIds'], 4, 5, 14, 15, 16], applicableForTaskTypeInsideCaseType: applicableForTaskTypeInsideCaseType }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.userDataOptions = response.items.map(userData => {
        return {
          value: getId(userData['@id']),
          text: userData.fullName,
          idClientType: getId(userData.idClientType)
        }
      })
      this.userDataOptions.unshift({ text: this.$t('global.all'), value: null, idClientType: 0 })
      this.userDataOptions.unshift({ text: this.$t('notAssigned'), value: false, idClientType: 0 })
    },
    getIdLink (link) {
      return getId(link)
    },
    onSelectCurrentTaskType (items) {
      this.currentTaskType = items
      this.searchParams['lastTask.idTaskType'] = items.map(option => getId(option.value))
    },
    onSelectKeyTaskType (items) {
      this.keyTaskType = items
      this.searchParams['idKeyTask.idTaskType'] = items.map(option => getId(option.value))
    }
  }
}
</script>
